import { ButtonWithDialog, Intent } from "@focus/focusUI";
import type { ApiKey } from "../../../types/apiKeys";

export const DeleteApiKeyButton = ({
  apiKey,
  disabled,
  onDelete,
}: {
  apiKey?: ApiKey;
  disabled?: boolean;
  onDelete: (id: string) => void;
}) => (
  <ButtonWithDialog<null>
    closeAfterAccept
    defaultContent={null}
    disabled={disabled || !apiKey}
    form={() => (
      <div className="w-full space-y-3 p-4 text-center">
        <p>
          Are you sure you want to delete{" "}
          <b>{apiKey?.name ?? "this API key"}</b>?
        </p>
        <p className="text-sm text-gray-500">This action cannot be undone.</p>
      </div>
    )}
    headerTitle="Confirm Delete"
    hideButtons={false}
    icon="trash"
    intent={Intent.DANGER}
    minimal
    onAccept={() => {
      if (apiKey) {
        onDelete(apiKey.id);
      }
    }}
    tooltipText="Delete API key"
  />
);